import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  loadingDescriptionManual: false,
  loadingPdfDocument: false,
  saveLoading: false,
  saveLoadingById: false,
  generalInfosLength: 0,
  generalInfos: [],
  docDescriptor: null,
  pdfDescriptor: null,
  generalInfo: {},
  generalInfoError: "",
  formError: "",
  descriptorAcepta: "",
};

export default function GeneralInfoReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_GENERAL_INFO:
      return { ...state, loading: action.payload };
    case actions.LOADING_GENERAL_INFO_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_GENERAL_INFO:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_GENERAL_INFO_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_GENERAL_INFO:
      return {
        ...state,
        generalInfos: action.payload.generalInfos,
        generalInfosLength: action.payload.generalInfosLength,
      };
    case actions.GET_DESCRIPTOR:
      return { ...state, descriptorAcepta: action.payload };
    case actions.GET_GENERAL_INFO_BY_ID:
      return {
        ...state,
        generalInfo: action.payload,
      };
    case actions.FORM_FAIL_GENERAL_INFO:
      return { ...state, formError: action.payload };
    case actions.GENERAL_INFO_FAIL:
      return { ...state, generalInfoError: action.payload };
    case actions.LOADING_DESCRIPTOR_MANUAL:
      return { ...state, loadingDescriptionManual: action.payload };
    case actions.DOC_DESCRIPTOR:
      return {
        ...state,
        docDescriptor: action.payload,
      };
    case actions.LOADING_PDF_DESCRIPTOR:
      return { ...state, loadingPdfDocument: action.payload };
    case actions.PDF_DESCRIPTOR:
      return {
        ...state,
        pdfDescriptor: action.payload,
      };
    default:
      return state;
  }
}
